import { render } from "./TwitchCategorySelect.vue?vue&type=template&id=742ba00e"
import script from "./TwitchCategorySelect.vue?vue&type=script&lang=ts"
export * from "./TwitchCategorySelect.vue?vue&type=script&lang=ts"
script.render = render

export default script